import { render, staticRenderFns } from "./HuiZhangJianJie.vue?vue&type=template&id=4b8a3da2&scoped=true&"
import script from "./HuiZhangJianJie.vue?vue&type=script&lang=js&"
export * from "./HuiZhangJianJie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a3da2",
  null
  
)

export default component.exports